import { Routes } from '@angular/router';
import { FullComponent } from './layouts/full/full.component';
import { AppLandingComponent } from './layouts/full/app-landing/app-landing.component';
import { LoginPageComponent } from './apps/auth/pages/login-page/login-page.component';
import { LoginMainComponent } from './apps/auth/components/login-main/login-main.component';
import { LoginCedulaComponent } from './apps/auth/components/login-cedula/login-cedula.component';
import { BlankComponent } from './layouts/blank/blank.component';
import { LoginEmailComponent } from './apps/auth/components/login-email/login-email.component';
import { LoginAzureComponent } from './apps/auth/components/login-azure/login-azure.component';
import { ErrorPageComponent } from './shared/components/error-page/error-page.component';
import { TokenGuard } from './shared/guards/token.guard';
import { InformacionCandidatoPage } from './apps/info-candidatos/pages/informacion-candidato-page/informacion-candidato-page';
import { InfoCandidateResume } from './apps/info-candidatos/pages/info-candidate-resume/info-candidate-resume';

export const routes: Routes = [
  {
    path: 'login',
    component: BlankComponent,
    children: [
      {
        path: '',
        component: LoginPageComponent,
        children: [
          {
            path: '',
            component: LoginMainComponent
          },
          {
            path: 'cedula',
            component: LoginCedulaComponent
          },
          {
            path: 'email',
            component: LoginEmailComponent
          },
          {
            path: 'azure-auth',
            component: LoginAzureComponent
          }
        ],
        data: {
          title: 'Iniciar Sesión',
          breadcrumb: 'Iniciar Sesión'
        }
      }
    ],
    data: {
      title: 'Iniciar Sesión',
      breadcrumb: 'Iniciar Sesión'
    }
  },
  {
    path: 'app',
    component: FullComponent,
    children: [
      {
        // '/app' sin hijo no hacía match con ninguna ruta: la navegación fallaba, el usuario
        // se quedaba en /login con el loader "Cargando información del usuario..." colgado
        // (login por correo navega a '/app'). Este hijo vacío mantiene la ruta válida mientras
        // FullComponent carga los menús y redirige al primer menú del portal del usuario.
        path: '',
        pathMatch: 'full',
        canActivate: [TokenGuard],
        component: AppLandingComponent,
        data: {
          title: 'Inicio',
          breadcrumb: 'Inicio'
        }
      },
      {
        path: 'nodo',
        canActivate: [TokenGuard],
        loadChildren: () => import('./apps/nodo/nodo.routes').then((m) => m.NodoRoutes),
        data: {
          title: 'Nodo',
          breadcrumb: 'Nodo'
        }
      },
      {
        path: 'mi-portal',
        canActivate: [TokenGuard],
        loadChildren: () => import('./apps/portal-personas/portal-personas.routes').then((m) => m.PortalPersonasRoutes),
        data: {
          title: 'Mi Portal',
          breadcrumb: 'Mi Portal'
        }
      },
      {
        path: 'empresas',
        canActivate: [TokenGuard],
        loadChildren: () => import('./apps/empresas/empresas.routes').then((m) => m.EmpresasRoutes),
        data: {
          title: 'Empresas',
          breadcrumb: 'Empresas'
        }
      }
    ],
    data: {
      title: 'Inicio',
      breadcrumb: 'Inicio'
    }
  },
  {
    path: 'info-candidatos',
    component: BlankComponent,
    children: [
      {
        path: '',
        component: InformacionCandidatoPage,
        data: {
          title: 'Información de Candidatos',
          breadcrumb: 'Información de Candidatos'
        }
      },
      {
        path: 'resume',
        component: InfoCandidateResume,
        data: {
          title: 'Resumen del Candidato',
          breadcrumb: 'Resumen del Candidato'
        }
      }
    ]
  },
  {
    path: 'registro',
    component: BlankComponent,
    children: [
      {
        path: '',
        loadComponent: () =>
          import('./apps/registro-publico/pages/registro-publico-page/registro-publico-page').then(
            (m) => m.RegistroPublicoPage
          ),
        data: { title: 'Registro de personas', breadcrumb: 'Registro' }
      },
      {
        path: 'gracias',
        loadComponent: () =>
          import('./apps/registro-publico/pages/registro-publico-gracias/registro-publico-gracias').then(
            (m) => m.RegistroPublicoGracias
          ),
        data: { title: 'Registro recibido', breadcrumb: 'Registro recibido' }
      }
    ]
  },
  {
    path: 'error-page',
    component: BlankComponent,
    children: [
      {
        path: '',
        component: ErrorPageComponent,
        data: {
          title: 'Error',
          breadcrumb: 'Error'
        }
      }
    ],
    data: {
      title: 'Error',
      breadcrumb: 'Error'
    }
  },
  {
    path: '',
    redirectTo: 'app',
    pathMatch: 'full',
    data: {
      title: 'Iniciar Sesión',
      breadcrumb: 'Iniciar Sesión'
    }
  },
  {
    path: '**',
    redirectTo: 'login',
    pathMatch: 'full'
  }
];
